<template>
  <v-container>
    <v-card>
      <v-row align="center" class="py-1 px-2" no-gutters>
        <v-col cols="12" sm="6">
          <v-breadcrumbs class="px-2" :items="breadcrumbsItems"></v-breadcrumbs>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          :class="$store.getters.LANGUAGE == 'fa' ? 'text-left' : 'text-right'"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                class="mx-2"
                v-bind="attrs"
                v-on="on"
                color="orange"
                @click="helpDialog = true"
              >
                <v-icon small>fa-question</v-icon>
              </v-btn>
            </template>
            <span>{{ $vuetify.lang.translator("showHelp") }}</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-container>
        <v-form ref="form" v-model="valid" @submit.prevent="getImages">
          <v-row>
            <v-col cols="12" md="6" lg="3">
              <div>{{ $vuetify.lang.translator("employers") }} *</div>
              <v-row>
                <v-col>
                  <v-autocomplete
                    :items="allEmployers"
                    item-text="name"
                    item-value="id"
                    :placeholder="$vuetify.lang.translator('chooseAnOption')"
                    v-model="searchFields.employer_id"
                    clearable
                    autofocus
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="6" lg="3">
              <div>{{ $vuetify.lang.translator("line") }} *</div>
              <v-row>
                <v-col>
                  <v-autocomplete
                    :items="allLines"
                    item-text="name"
                    item-value="id"
                    :placeholder="$vuetify.lang.translator('chooseAnOption')"
                    v-model="searchFields.line_id"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="6" lg="3">
              <div>
                {{ $vuetify.lang.translator("errorType") }}
              </div>
              <v-row>
                <v-col>
                  <v-select
                    :items="allErrorTypes"
                    item-text="name"
                    item-value="id"
                    :placeholder="$vuetify.lang.translator('chooseAnOption')"
                    v-model="searchFields.error_type"
                    clearable
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="6" lg="3">
              <div>
                {{ $vuetify.lang.translator("error") }}
              </div>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="searchFields.name"
                    :placeholder="$vuetify.lang.translator('errorName')"
                    type="text"
                    autocomplete="on"
                    clearable
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="auto">
              <v-btn
                color="primary"
                :loading="loading"
                :disabled="loading"
                type="submit"
              >
                <v-icon class="mx-2">fa-search</v-icon
                >{{ $vuetify.lang.translator("search") }}</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>

    <v-card class="mt-6">
      <v-row align="center">
        <v-col cols="12" sm="6">
          <div class="mx-2">{{ $vuetify.lang.translator("searchResult") }}</div>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          :class="$store.getters.LANGUAGE == 'fa' ? 'text-left' : 'text-right'"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                color="primary"
                class="mx-2"
                v-bind="attrs"
                v-on="on"
                @click="helpDialog = true"
              >
                <v-icon small>fa-map-marked-alt</v-icon>
              </v-btn>
            </template>
            <span>{{ $vuetify.lang.translator("searchResultOnMap") }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-left">
          <div class="ml-3">
            <span class="ml-8 ">{{ pages }}</span>
            <v-btn icon class="ml-3"><v-icon>fa-chevron-right</v-icon></v-btn>
            <v-btn icon class="ml-3"><v-icon>fa-chevron-left</v-icon></v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <v-dialog
      v-model="helpDialog"
      persistent
      max-width="800"
      @keydown.esc="helpDialog = false"
      transition="dialog-top-transition"
    >
      <v-card>
        <v-toolbar dense elevation="2">
          <v-toolbar-title>{{
            $vuetify.lang.translator("help")
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="helpDialog = false">
              <v-icon>fa-times</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <div
            class="mt-6"
            v-html="$vuetify.lang.translator('searchImagesHelp')"
          ></div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="success" @click="helpDialog = false">{{
            $vuetify.lang.translator("gotIt")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { handleError } from "@/helpers/helper";
// import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "SearchImages",
  // components: {
  //   VuePersianDatetimePicker
  // },
  data: () => ({
    breadcrumbsItems: [],
    valid: false,
    searchFields: {
      employer_id: null,
      line_id: null,
      error_type: null,
      name: null
    },
    allEmployers: [],
    allLines: [],
    allErrorTypes: [],
    items: [],
    totalItems: 0,
    loading: false,
    helpDialog: false,
    pages: "-"
  }),
  created() {
    this.checkPrivileges();

    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("dashboard"),
      to: { name: "Dashboard" }
    });
    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("searchImages"),
      to: { name: "SearchImages" }
    });

    this.allErrorTypes.push({
      id: 1,
      name: this.$vuetify.lang.translator("normal")
    });
    this.allErrorTypes.push({
      id: 2,
      name: this.$vuetify.lang.translator("warning")
    });
    this.allErrorTypes.push({
      id: 3,
      name: this.$vuetify.lang.translator("critical")
    });

    this.getEmployers();
  },
  methods: {
    checkPrivileges() {
      let userType = parseInt(this.$store.getters.USERTYPE);
      let allowed_privileges = [1, 2, 3, 4, 5, 6, 7];
      if (allowed_privileges.indexOf(userType) === -1) {
        this.$router.push({ name: "Error403" });
      }
    },
    getEmployers() {
      var self = this;
      this.$http
        .get("/employer/list/")
        .then(function(response) {
          self.allEmployers = response.data;
        })
        .catch(function(error) {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        });
    },
    getLines() {
      var self = this;
      this.$http
        .get("/line/list/")
        .then(function(response) {
          self.allLines = response.data;
        })
        .catch(function(error) {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        });
    },
    getImages() {
      let data = this.getSearchCriteria();
      if (Object.entries(data).length === 0) {
        return;
      }
      data.excel = false;
      this.loading = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      var parameters = null;
      if (sortBy[0]) {
        parameters = {
          page: page,
          size: itemsPerPage,
          sort: (sortDesc[0] ? "-" : "") + sortBy[0]
        };
      } else {
        parameters = {
          page: page,
          size: itemsPerPage
        };
      }
      var self = this;
      this.$http
        .post("/search/activity/", data, {
          params: parameters
        })
        .then(function(response) {
          self.items = response.data.results;
          self.totalItems = response.data.count;
          if (self.totalItems === 0) {
            self.$toasted.info("اطلاعاتی یافت نشد", {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        })
        .catch(function(error) {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        })
        .then(function() {
          self.loading = false;
        });
    },
    getSearchCriteria() {
      let result = {};
      if (
        Object.values(this.searchFields).every(
          o => o === null || o === undefined || o === ""
        )
      ) {
        this.$toasted.info("حداقل یک گزینه را انتخاب/وارد کنید", {
          duration: 5000,
          keepOnHover: true,
          className:
            this.$store.getters.LANGUAGE == "fa"
              ? "vazir-font-fd"
              : "vazir-font",
          iconPack: "fontawesome",
          icon: "exclamation-triangle",
          position: "top-center"
        });
        return result;
      }
      if (this.searchFields.line_id) {
        result.line_id = this.searchFields.line_id;
      }
      if (this.searchFields.error_type) {
        result.error_type = this.searchFields.error_type;
      }
      if (this.searchFields.activity) {
        result.activity = this.searchFields.activity;
      }
      if (this.searchFields.ip) {
        result.ip = this.searchFields.ip;
      }
      if (
        this.searchFields.created_at_from &&
        this.searchFields.created_at_to
      ) {
        result.created_at_from = this.searchFields.created_at_from;
        result.created_at_to = this.searchFields.created_at_to;
      }
      return result;
    }
  }
};
</script>
